import { render, staticRenderFns } from "./product-match.vue?vue&type=template&id=e0f26222&scoped=true"
import script from "./product-match.vue?vue&type=script&lang=js"
export * from "./product-match.vue?vue&type=script&lang=js"
import style0 from "./product-match.vue?vue&type=style&index=0&id=e0f26222&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0f26222",
  null
  
)

export default component.exports